import { Option } from '@companio/companio_ui';
import { UserLocale } from '@/types/user';
import { GenericSelectOption } from './general_contants';

export const CURRENCIES = [
  { code: 'EUR', name: 'Euro', default: true, symbol: '&#8364;', actualSymbol: '€' },
  { code: 'USD', name: 'United States dollar', symbol: '&#36;', actualSymbol: '$' },
  {
    code: 'AED',
    name: 'United Arab Emirates dirham',
    symbol: '&#1583;.&#1573;',
    actualSymbol: 'د.إ'
  },
  { code: 'AFN', name: 'Afghan afghani', symbol: '&#65;&#102;', actualSymbol: 'Af' },
  { code: 'ALL', name: 'Albanian lek', symbol: '&#76;&#101;&#107;', actualSymbol: 'Lek' },
  { code: 'AMD', name: 'Armenian dram', symbol: 'AMD', actualSymbol: 'AMD' },
  { code: 'AOA', name: 'Angolan kwanza', symbol: '&#75;&#122;', actualSymbol: 'Kz' },
  { code: 'ARS', name: 'Argentine peso', symbol: '&#36;', actualSymbol: '$' },
  { code: 'AUD', name: 'Australian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'AWG', name: 'Aruban florin', symbol: '&#402;', actualSymbol: 'ƒ' },
  { code: 'AZN', name: 'Azerbaijani manat', symbol: '&#1084;&#1072;&#1085;', actualSymbol: 'ман' },
  {
    code: 'BAM',
    name: 'Bosnia and Herzegovina convertible mark',
    symbol: '&#75;&#77;',
    actualSymbol: 'KM'
  },
  { code: 'BBD', name: 'Barbadian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'BDT', name: 'Bangladeshi taka', symbol: '&#2547;', actualSymbol: '৳' },
  { code: 'BGN', name: 'Bulgarian lev', symbol: '&#1083;&#1074;', actualSymbol: 'лв' },
  { code: 'BHD', name: 'Bahraini dinar', symbol: '.&#1583;.&#1576;', actualSymbol: '.د.ب' },
  { code: 'BIF', name: 'Burundian franc', symbol: '&#70;&#66;&#117;', actualSymbol: 'FBu' },
  { code: 'BMD', name: 'Bermudian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'BND', name: 'Brunei dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'BOB', name: 'Bolivian boliviano', symbol: '&#36;&#98;', actualSymbol: '$b' },
  { code: 'BRL', name: 'Brazilian real', symbol: '&#82;&#36;', actualSymbol: 'R$' },
  { code: 'BSD', name: 'Bahamian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'BTN', name: 'Bhutanese ngultrum', symbol: '&#78;&#117;&#46;', actualSymbol: 'Nu.' },
  { code: 'BWP', name: 'Botswana pula', symbol: '&#80;', actualSymbol: 'P' },
  { code: 'BYR', name: 'Belarusian ruble', symbol: '&#112;&#46;', actualSymbol: 'p.' },
  { code: 'BZD', name: 'Belize dollar', symbol: '&#66;&#90;&#36;', actualSymbol: 'BZ$' },
  { code: 'CAD', name: 'Canadian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'CDF', name: 'Congolese franc', symbol: '&#70;&#67;', actualSymbol: 'FC' },
  { code: 'CHF', name: 'Swiss franc', symbol: '&#67;&#72;&#70;', actualSymbol: 'CHF' },
  { code: 'CLP', name: 'Chilean peso', symbol: '&#36;', actualSymbol: '$' },
  { code: 'CNY', name: 'Chinese yuan', symbol: '&#165;', actualSymbol: '¥' },
  { code: 'COP', name: 'Colombian peso', symbol: '&#36;', actualSymbol: '$' },
  { code: 'CRC', name: 'Costa Rican colón', symbol: '&#8353;', actualSymbol: '₡' },
  { code: 'CUP', name: 'Cuban convertible peso', symbol: 'CUC$', actualSymbol: 'CUC$' },
  { code: 'CVE', name: 'Cape Verdean escudo', symbol: '&#36;', actualSymbol: '$' },
  { code: 'CZK', name: 'Czech koruna', symbol: '&#75;&#269;', actualSymbol: 'Kč' },
  { code: 'DJF', name: 'Djiboutian franc', symbol: '&#70;&#100;&#106;', actualSymbol: 'Fdj' },
  { code: 'DKK', name: 'Danish krone', symbol: '&#107;&#114;', actualSymbol: 'kr' },
  { code: 'DOP', name: 'Dominican peso', symbol: '&#82;&#68;&#36;', actualSymbol: 'RD$' },
  { code: 'DZD', name: 'Algerian dinar', symbol: '&#1583;&#1580;', actualSymbol: 'دج' },
  { code: 'EGP', name: 'Egyptian pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'ERN', name: 'Eritrean nakfa', symbol: 'ERN', actualSymbol: 'ERN' },
  { code: 'ETB', name: 'Ethiopian birr', symbol: '&#66;&#114;', actualSymbol: 'Br' },
  { code: 'FJD', name: 'Fijian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'FKP', name: 'Falkland Islands pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'GBP', name: 'British pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'GEL', name: 'Georgian lari', symbol: '&#4314;', actualSymbol: '₾' },
  { code: 'GHS', name: 'Ghana cedi', symbol: '&#162;', actualSymbol: '¢' },
  { code: 'GMD', name: 'Gambian dalasi', symbol: '&#68;', actualSymbol: 'D' },
  { code: 'GNF', name: 'Guinean franc', symbol: '&#70;&#71;', actualSymbol: 'FG' },
  { code: 'GTQ', name: 'Guatemalan quetzal', symbol: '&#81;', actualSymbol: 'Q' },
  { code: 'GYD', name: 'Guyanese dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'HKD', name: 'Hong Kong dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'HNL', name: 'Honduran lempira', symbol: '&#76;', actualSymbol: 'L' },
  { code: 'HRK', name: 'Croatian kuna', symbol: '&#107;&#110;', actualSymbol: 'kn' },
  { code: 'HTG', name: 'Haitian gourde', symbol: '&#71;', actualSymbol: 'G' },
  { code: 'HUF', name: 'Hungarian forint', symbol: '&#70;&#116;', actualSymbol: 'Ft' },
  { code: 'IDR', name: 'Indonesian rupiah', symbol: '&#82;&#112;', actualSymbol: 'Rp' },
  { code: 'ILS', name: 'Israeli new shekel', symbol: '&#8362;', actualSymbol: '₪' },
  { code: 'IMP', name: 'Manx pound', symbol: 'IMP', actualSymbol: 'IMP' },
  { code: 'INR', name: 'Indian rupee', symbol: '&#8377;', actualSymbol: '₹' },
  { code: 'IQD', name: 'Iraqi dinar', symbol: '&#1593;.&#1583;', actualSymbol: 'ع.د' },
  { code: 'IRR', name: 'Iranian rial', symbol: '&#65020;', actualSymbol: '﷼' },
  { code: 'ISK', name: 'Icelandic króna', symbol: '&#107;&#114;', actualSymbol: 'kr' },
  { code: 'JEP', name: 'Jersey pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'JMD', name: 'Jamaican dollar', symbol: '&#74;&#36;', actualSymbol: 'J$' },
  { code: 'JOD', name: 'Jordanian dinar', symbol: '&#74;&#68;', actualSymbol: 'JD' },
  { code: 'JPY', name: 'Japanese yen', symbol: '&#165;', actualSymbol: '¥' },
  { code: 'KES', name: 'Kenyan shilling', symbol: '&#75;&#83;&#104;', actualSymbol: 'KSh' },
  { code: 'KGS', name: 'Kyrgyzstani som', symbol: '&#1083;&#1074;', actualSymbol: 'лв' },
  { code: 'KHR', name: 'Cambodian riel', symbol: '&#6107;', actualSymbol: '៛' },
  { code: 'KMF', name: 'Comorian franc', symbol: '&#67;&#70;', actualSymbol: 'CF' },
  { code: 'KPW', name: 'North Korean won', symbol: '&#8361;', actualSymbol: '₩' },
  { code: 'KRW', name: 'South Korean won', symbol: '&#8361;', actualSymbol: '₩' },
  { code: 'KWD', name: 'Kuwaiti dinar', symbol: '&#1583;.&#1603;', actualSymbol: 'د.ك' },
  { code: 'KYD', name: 'Cayman Islands dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'KZT', name: 'Kazakhstani tenge', symbol: '&#1083;&#1074;', actualSymbol: 'лв' },
  { code: 'LAK', name: 'Laotian kip', symbol: '&#8365;', actualSymbol: '₭' },
  { code: 'LBP', name: 'Lebanese pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'LKR', name: 'Sri Lankan rupee', symbol: '&#8360;', actualSymbol: '₨' },
  { code: 'LRD', name: 'Liberian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'LSL', name: 'Lesotho loti', symbol: '&#76;', actualSymbol: 'L' },
  { code: 'LTL', name: 'Lithuanian litas', symbol: '&#76;&#116;', actualSymbol: 'Lt' },
  { code: 'LVL', name: 'Latvian lats', symbol: '&#76;&#115;', actualSymbol: 'Ls' },
  { code: 'LYD', name: 'Libyan dinar', symbol: '&#1604;.&#1583;', actualSymbol: 'ل.د' },
  { code: 'MAD', name: 'Moroccan dirham', symbol: '&#1583;.&#1605;.', actualSymbol: 'د.م.' },
  { code: 'MDL', name: 'Moldovan leu', symbol: '&#76;', actualSymbol: 'L' },
  { code: 'MGA', name: 'Malagasy ariary', symbol: '&#65;&#114;', actualSymbol: 'Ar' },
  { code: 'MKD', name: 'Macedonian denar', symbol: '&#1076;&#1077;&#1085;', actualSymbol: 'ден' },
  { code: 'MMK', name: 'Burmese kyat', symbol: '&#75;', actualSymbol: 'K' },
  { code: 'MNT', name: 'Mongolian tögrög', symbol: '&#8366;', actualSymbol: '₮' },
  { code: 'MOP', name: 'Macanese pataca', symbol: '&#77;&#79;&#80;&#36;', actualSymbol: 'MOP$' },
  { code: 'MRO', name: 'Mauritanian ouguiya', symbol: '&#85;&#77;', actualSymbol: 'UM' },
  { code: 'MUR', name: 'Mauritian rupee', symbol: '&#8360;', actualSymbol: '₨' },
  { code: 'MVR', name: 'Maldivian rufiyaa', symbol: '.&#1923;', actualSymbol: '.ރ' },
  { code: 'MWK', name: 'Malawian kwacha', symbol: '&#77;&#75;', actualSymbol: 'MK' },
  { code: 'MXN', name: 'Mexican peso', symbol: '&#36;', actualSymbol: '$' },
  { code: 'MYR', name: 'Malaysian ringgit', symbol: '&#82;&#77;', actualSymbol: 'RM' },
  { code: 'MZN', name: 'Mozambican metical', symbol: '&#77;&#84;', actualSymbol: 'MT' },
  { code: 'NAD', name: 'Namibian dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'NGN', name: 'Nigerian naira', symbol: '&#8358;', actualSymbol: '₦' },
  { code: 'NIO', name: 'Nicaraguan córdoba', symbol: '&#67;&#36;', actualSymbol: 'C$' },
  { code: 'NOK', name: 'Norwegian krone', symbol: '&#107;&#114;', actualSymbol: 'kr' },
  { code: 'NPR', name: 'Nepalese rupee', symbol: '&#8360;', actualSymbol: '₨' },
  { code: 'NZD', name: 'New Zealand dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'OMR', name: 'Omani rial', symbol: '&#65020;', actualSymbol: '﷼' },
  { code: 'PAB', name: 'Panamanian balboa', symbol: '&#66;&#47;&#46;', actualSymbol: 'B/.' },
  { code: 'PEN', name: 'Peruvian nuevo sol', symbol: '&#83;&#47;&#46;', actualSymbol: 'S/.' },
  { code: 'PGK', name: 'Papua New Guinean kina', symbol: '&#75;', actualSymbol: 'K' },
  { code: 'PHP', name: 'Philippine peso', symbol: '&#8369;', actualSymbol: '₱' },
  { code: 'PKR', name: 'Pakistani rupee', symbol: '&#8360;', actualSymbol: '₨' },
  { code: 'PLN', name: 'Polish złoty', symbol: '&#122;&#322;', actualSymbol: 'zł' },
  { code: 'PRB', name: 'Transnistrian ruble', symbol: 'PRB', actualSymbol: 'PRB' },
  { code: 'PYG', name: 'Paraguayan guaraní', symbol: '&#71;&#115;', actualSymbol: 'Gs' },
  { code: 'QAR', name: 'Qatari riyal', symbol: '&#65020;', actualSymbol: '﷼' },
  { code: 'RON', name: 'Romanian leu', symbol: '&#108;&#101;&#105;', actualSymbol: 'lei' },
  {
    code: 'RSD',
    name: 'Serbian dinar',
    symbol: '&#1044;&#1080;&#1085;&#46;',
    actualSymbol: 'дин.'
  },
  { code: 'RUB', name: 'Russian ruble', symbol: '&#8381;', actualSymbol: '₽' },
  { code: 'RWF', name: 'Rwandan franc', symbol: '&#1585;.&#1587;', actualSymbol: 'ر.س' },
  { code: 'SAR', name: 'Saudi riyal', symbol: '&#65020;', actualSymbol: '﷼' },
  { code: 'SBD', name: 'Solomon Islands dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'SCR', name: 'Seychellois rupee', symbol: '&#8360;', actualSymbol: '₨' },
  { code: 'SDG', name: 'Singapore dollar', symbol: '&#163;', actualSymbol: '£' },
  { code: 'SEK', name: 'Swedish krona', symbol: '&#107;&#114;', actualSymbol: 'kr' },
  { code: 'SGD', name: 'Singapore dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'SHP', name: 'Saint Helena pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'SLL', name: 'Sierra Leonean leone', symbol: '&#76;&#101;', actualSymbol: 'Le' },
  { code: 'SOS', name: 'Somali shilling', symbol: '&#83;', actualSymbol: 'S' },
  { code: 'SRD', name: 'Surinamese dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'SSP', name: 'South Sudanese pound', symbol: 'SSP', actualSymbol: 'SSP' },
  { code: 'STD', name: 'São Tomé and Príncipe dobra', symbol: '&#68;&#98;', actualSymbol: 'Db' },
  { code: 'SVC', name: 'Salvadoran colón', symbol: '&#36;', actualSymbol: '$' },
  { code: 'SYP', name: 'Syrian pound', symbol: '&#163;', actualSymbol: '£' },
  { code: 'SZL', name: 'Swazi lilangeni', symbol: '&#76;', actualSymbol: 'L' },
  { code: 'THB', name: 'Thai baht', symbol: '&#3647;', actualSymbol: '฿' },
  { code: 'TJS', name: 'Tajikistani somoni', symbol: '&#84;&#74;&#83;', actualSymbol: 'TJS' },
  { code: 'TMT', name: 'Turkmenistan manat', symbol: '&#109;', actualSymbol: 'm' },
  { code: 'TND', name: 'Tunisian dinar', symbol: '&#1583;.&#1578;', actualSymbol: 'د.ت' },
  { code: 'TOP', name: 'Tongan paʻanga', symbol: '&#84;&#36;', actualSymbol: 'T$' },
  { code: 'TRY', name: 'Turkish lira', symbol: '&#8356;', actualSymbol: '₺' },
  { code: 'TTD', name: 'Trinidad and Tobago dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'TWD', name: 'New Taiwan dollar', symbol: '&#78;&#84;&#36;', actualSymbol: 'NT$' },
  { code: 'TZS', name: 'Tanzanian shilling', symbol: 'TZS', actualSymbol: 'TZS' },
  { code: 'UAH', name: 'Ukrainian hryvnia', symbol: '&#8372;', actualSymbol: '₴' },
  { code: 'UGX', name: 'Ugandan shilling', symbol: '&#85;&#83;&#104;', actualSymbol: 'USh' },
  { code: 'UYU', name: 'Uruguayan peso', symbol: '&#36;&#85;', actualSymbol: '$U' },
  { code: 'UZS', name: 'Uzbekistani som', symbol: '&#1083;&#1074;', actualSymbol: 'лв' },
  { code: 'VEF', name: 'Venezuelan bolívar', symbol: '&#66;&#115;', actualSymbol: 'Bs' },
  { code: 'VND', name: 'Vietnamese đồng', symbol: '&#8363;', actualSymbol: '₫' },
  { code: 'VUV', name: 'Vanuatu vatu', symbol: '&#86;&#84;', actualSymbol: 'VT' },
  { code: 'WST', name: 'Samoan tālā', symbol: '&#87;&#83;&#36;', actualSymbol: 'WS$' },
  {
    code: 'XAF',
    name: 'Central African CFA franc',
    symbol: '&#70;&#67;&#70;&#65;',
    actualSymbol: 'FCFA'
  },
  { code: 'XCD', name: 'East Caribbean dollar', symbol: '&#36;', actualSymbol: '$' },
  { code: 'XOF', name: 'West African CFA franc', symbol: 'XOF', actualSymbol: 'XOF' },
  { code: 'XPF', name: 'CFP franc', symbol: '&#70;', actualSymbol: 'F' },
  { code: 'YER', name: 'Yemeni rial', symbol: '&#65020;', actualSymbol: '﷼' },
  { code: 'ZAR', name: 'South African rand', symbol: '&#82;', actualSymbol: 'R' },
  { code: 'ZMW', name: 'Zambian kwacha', symbol: 'ZMW', actualSymbol: 'ZMW' },
  { code: 'ZWL', name: 'Zimbabwean dollar', symbol: '&#90;&#36;', actualSymbol: 'Z$' },
  { code: 'BTC', name: 'Bitcoin', symbol: 'BTC', actualSymbol: 'BTC' },
  { code: 'ETH', name: 'Ethereum', symbol: 'ETH', actualSymbol: 'ETH' },
  { code: 'LTC', name: 'Litecoin', symbol: 'LTC', actualSymbol: 'LTC' },
  { code: 'BCH', name: 'Bitcoin Cash', symbol: 'BCH', actualSymbol: 'BCH' },
  { code: 'SOL', name: 'Solana', symbol: 'SOL', actualSymbol: 'SOL' },
  { code: 'XRP', name: 'Ripple', symbol: 'XRP', actualSymbol: 'XRP' }
];

export const MAPPED_CURRENCIES = CURRENCIES.reduce((acc, current) => {
  return { ...acc, [current.code]: current };
}, {});

export const COUNTRIES: { code: string; name: string; phone_code: string }[] = [
  { code: 'AF', name: 'Afghanistan', phone_code: '+93' },
  { code: 'AX', name: 'Aland Islands', phone_code: '+358' },
  { code: 'AL', name: 'Albania', phone_code: '+355' },
  { code: 'DZ', name: 'Algeria', phone_code: '+213' },
  { code: 'AS', name: 'American Samoa', phone_code: '+1-684' },
  { code: 'AD', name: 'Andorra', phone_code: '+376' },
  { code: 'AO', name: 'Angola', phone_code: '+244' },
  { code: 'AI', name: 'Anguilla', phone_code: '+1-264' },
  { code: 'AQ', name: 'Antarctica', phone_code: '' },
  { code: 'AG', name: 'Antigua and Barbuda', phone_code: '+1-268' },
  { code: 'AR', name: 'Argentina', phone_code: '+54' },
  { code: 'AM', name: 'Armenia', phone_code: '+374' },
  { code: 'AW', name: 'Aruba', phone_code: '+297' },
  { code: 'AU', name: 'Australia', phone_code: '+61' },
  { code: 'AT', name: 'Austria', phone_code: '+43' },
  { code: 'AZ', name: 'Azerbaijan', phone_code: '+994' },
  { code: 'BS', name: 'Bahamas', phone_code: '+1-242' },
  { code: 'BH', name: 'Bahrain', phone_code: '+973' },
  { code: 'BD', name: 'Bangladesh', phone_code: '+880' },
  { code: 'BB', name: 'Barbados', phone_code: '+1-246' },
  { code: 'BY', name: 'Belarus', phone_code: '+375' },
  { code: 'BE', name: 'Belgium', phone_code: '+32' },
  { code: 'BZ', name: 'Belize', phone_code: '+501' },
  { code: 'BJ', name: 'Benin', phone_code: '+229' },
  { code: 'BM', name: 'Bermuda', phone_code: '+1-441' },
  { code: 'BT', name: 'Bhutan', phone_code: '+975' },
  { code: 'BO', name: 'Bolivia', phone_code: '+591' },
  { code: 'BQ', name: 'Bonaire, Sint Eustatius and Saba', phone_code: '+599' },
  { code: 'BA', name: 'Bosnia and Herzegovina', phone_code: '+387' },
  { code: 'BW', name: 'Botswana', phone_code: '+267' },
  { code: 'BV', name: 'Bouvet Island', phone_code: '' },
  { code: 'BR', name: 'Brazil', phone_code: '+55' },
  { code: 'IO', name: 'British Indian Ocean Territory', phone_code: '+246' },
  { code: 'BN', name: 'Brunei', phone_code: '+673' },
  { code: 'BG', name: 'Bulgaria', phone_code: '+359' },
  { code: 'BF', name: 'Burkina Faso', phone_code: '+226' },
  { code: 'BI', name: 'Burundi', phone_code: '+257' },
  { code: 'KH', name: 'Cambodia', phone_code: '+855' },
  { code: 'CM', name: 'Cameroon', phone_code: '+237' },
  { code: 'CA', name: 'Canada', phone_code: '+1' },
  { code: 'CV', name: 'Cape Verde', phone_code: '+238' },
  { code: 'KY', name: 'Cayman Islands', phone_code: '+1-345' },
  { code: 'CF', name: 'Central African Republic', phone_code: '+236' },
  { code: 'TD', name: 'Chad', phone_code: '+235' },
  { code: 'CL', name: 'Chile', phone_code: '+56' },
  { code: 'CN', name: 'China', phone_code: '+86' },
  { code: 'CX', name: 'Christmas Island', phone_code: '+61' },
  { code: 'CC', name: 'Cocos (Keeling) Islands', phone_code: '+61' },
  { code: 'CO', name: 'Colombia', phone_code: '+57' },
  { code: 'KM', name: 'Comoros', phone_code: '+269' },
  { code: 'CG', name: 'Republic of the Congo', phone_code: '+242' },
  { code: 'CD', name: 'Democratic Republic of the Congo', phone_code: '+243' },
  { code: 'CK', name: 'Cook Islands', phone_code: '+682' },
  { code: 'CR', name: 'Costa Rica', phone_code: '+506' },
  { code: 'CI', name: 'Ivory Coast', phone_code: '+225' },
  { code: 'HR', name: 'Croatia', phone_code: '+385' },
  { code: 'CU', name: 'Cuba', phone_code: '+53' },
  { code: 'CW', name: 'Curacao', phone_code: '+599' },
  { code: 'CY', name: 'Cyprus', phone_code: '+357' },
  { code: 'CZ', name: 'Czech Republic', phone_code: '+420' },
  { code: 'DK', name: 'Denmark', phone_code: '+45' },
  { code: 'DJ', name: 'Djibouti', phone_code: '+253' },
  { code: 'DM', name: 'Dominica', phone_code: '+1-767' },
  { code: 'DO', name: 'Dominican Republic', phone_code: '+1-809' },
  { code: 'EC', name: 'Ecuador', phone_code: '+593' },
  { code: 'EG', name: 'Egypt', phone_code: '+20' },
  { code: 'SV', name: 'El Salvador', phone_code: '+503' },
  { code: 'GQ', name: 'Equatorial Guinea', phone_code: '+240' },
  { code: 'ER', name: 'Eritrea', phone_code: '+291' },
  { code: 'EE', name: 'Estonia', phone_code: '+372' },
  { code: 'ET', name: 'Ethiopia', phone_code: '+251' },
  { code: 'FK', name: 'Falkland Islands (Malvinas)', phone_code: '+500' },
  { code: 'FO', name: 'Faroe Islands', phone_code: '+298' },
  { code: 'FJ', name: 'Fiji', phone_code: '+679' },
  { code: 'FI', name: 'Finland', phone_code: '+358' },
  { code: 'FR', name: 'France', phone_code: '+33' },
  { code: 'GF', name: 'French Guiana', phone_code: '+594' },
  { code: 'PF', name: 'French Polynesia', phone_code: '+689' },
  { code: 'TF', name: 'French Southern Territories', phone_code: '' },
  { code: 'GA', name: 'Gabon', phone_code: '+241' },
  { code: 'GM', name: 'Gambia', phone_code: '+220' },
  { code: 'GE', name: 'Georgia', phone_code: '+995' },
  { code: 'DE', name: 'Germany', phone_code: '+49' },
  { code: 'GH', name: 'Ghana', phone_code: '+233' },
  { code: 'GI', name: 'Gibraltar', phone_code: '+350' },
  { code: 'GR', name: 'Greece', phone_code: '+30' },
  { code: 'GL', name: 'Greenland', phone_code: '+299' },
  { code: 'GD', name: 'Grenada', phone_code: '+1-473' },
  { code: 'GP', name: 'Guadeloupe', phone_code: '+590' },
  { code: 'GU', name: 'Guam', phone_code: '+1-671' },
  { code: 'GT', name: 'Guatemala', phone_code: '+502' },
  { code: 'GG', name: 'Guernsey', phone_code: '+44' },
  { code: 'GN', name: 'Guinea', phone_code: '+224' },
  { code: 'GW', name: 'Guinea-Bissau', phone_code: '+245' },
  { code: 'GY', name: 'Guyana', phone_code: '+592' },
  { code: 'HT', name: 'Haiti', phone_code: '+509' },
  { code: 'VA', name: 'Holy Vatican City State', phone_code: '+379' },
  { code: 'HN', name: 'Honduras', phone_code: '+504' },
  { code: 'HK', name: 'Hong Kong', phone_code: '+852' },
  { code: 'HU', name: 'Hungary', phone_code: '+36' },
  { code: 'IS', name: 'Iceland', phone_code: '+354' },
  { code: 'IN', name: 'India', phone_code: '+91' },
  { code: 'ID', name: 'Indonesia', phone_code: '+62' },
  { code: 'IR', name: 'Iran', phone_code: '+98' },
  { code: 'IQ', name: 'Iraq', phone_code: '+964' },
  { code: 'IE', name: 'Ireland', phone_code: '+353' },
  { code: 'IM', name: 'Isle of Man', phone_code: '+44' },
  { code: 'IL', name: 'Israel', phone_code: '+972' },
  { code: 'IT', name: 'Italy', phone_code: '+39' },
  { code: 'JM', name: 'Jamaica', phone_code: '+1-876' },
  { code: 'JP', name: 'Japan', phone_code: '+81' },
  { code: 'JE', name: 'Jersey', phone_code: '+44' },
  { code: 'JO', name: 'Jordan', phone_code: '+962' },
  { code: 'KZ', name: 'Kazakhstan', phone_code: '+7' },
  { code: 'KE', name: 'Kenya', phone_code: '+254' },
  { code: 'KI', name: 'Kiribati', phone_code: '+686' },
  { code: 'KP', name: 'North Korea', phone_code: '+850' },
  { code: 'KR', name: 'South Korea', phone_code: '+82' },
  { code: 'XK', name: 'Kosovo', phone_code: '+383' },
  { code: 'KW', name: 'Kuwait', phone_code: '+965' },
  { code: 'KG', name: 'Kyrgyzstan', phone_code: '+996' },
  { code: 'LA', name: 'Laos', phone_code: '+856' },
  { code: 'LV', name: 'Latvia', phone_code: '+371' },
  { code: 'LB', name: 'Lebanon', phone_code: '+961' },
  { code: 'LS', name: 'Lesotho', phone_code: '+266' },
  { code: 'LR', name: 'Liberia', phone_code: '+231' },
  { code: 'LY', name: 'Libya', phone_code: '+218' },
  { code: 'LI', name: 'Liechtenstein', phone_code: '+423' },
  { code: 'LT', name: 'Lithuania', phone_code: '+370' },
  { code: 'LU', name: 'Luxembourg', phone_code: '+352' },
  { code: 'MO', name: 'Macau', phone_code: '+853' },
  { code: 'MK', name: 'North Macedonia', phone_code: '+389' },
  { code: 'MG', name: 'Madagascar', phone_code: '+261' },
  { code: 'MW', name: 'Malawi', phone_code: '+265' },
  { code: 'MY', name: 'Malaysia', phone_code: '+60' },
  { code: 'MV', name: 'Maldives', phone_code: '+960' },
  { code: 'ML', name: 'Mali', phone_code: '+223' },
  { code: 'MT', name: 'Malta', phone_code: '+356' },
  { code: 'MH', name: 'Marshall Islands', phone_code: '+692' },
  { code: 'MQ', name: 'Martinique', phone_code: '+596' },
  { code: 'MR', name: 'Mauritania', phone_code: '+222' },
  { code: 'MU', name: 'Mauritius', phone_code: '+230' },
  { code: 'YT', name: 'Mayotte', phone_code: '+262' },
  { code: 'MX', name: 'Mexico', phone_code: '+52' },
  { code: 'FM', name: 'Micronesia', phone_code: '+691' },
  { code: 'MD', name: 'Moldova', phone_code: '+373' },
  { code: 'MC', name: 'Monaco', phone_code: '+377' },
  { code: 'MN', name: 'Mongolia', phone_code: '+976' },
  { code: 'ME', name: 'Montenegro', phone_code: '+382' },
  { code: 'MS', name: 'Montserrat', phone_code: '+1-664' },
  { code: 'MA', name: 'Morocco', phone_code: '+212' },
  { code: 'MZ', name: 'Mozambique', phone_code: '+258' },
  { code: 'MM', name: 'Myanmar', phone_code: '+95' },
  { code: 'NA', name: 'Namibia', phone_code: '+264' },
  { code: 'NR', name: 'Nauru', phone_code: '+674' },
  { code: 'NP', name: 'Nepal', phone_code: '+977' },
  { code: 'NL', name: 'Netherlands', phone_code: '+31' },
  { code: 'NC', name: 'New Caledonia', phone_code: '+687' },
  { code: 'NZ', name: 'New Zealand', phone_code: '+64' },
  { code: 'NI', name: 'Nicaragua', phone_code: '+505' },
  { code: 'NE', name: 'Niger', phone_code: '+227' },
  { code: 'NG', name: 'Nigeria', phone_code: '+234' },
  { code: 'NU', name: 'Niue', phone_code: '+683' },
  { code: 'NF', name: 'Norfolk Island', phone_code: '+672' },
  { code: 'MP', name: 'Northern Mariana Islands', phone_code: '+1-670' },
  { code: 'NO', name: 'Norway', phone_code: '+47' },
  { code: 'OM', name: 'Oman', phone_code: '+968' },
  { code: 'PK', name: 'Pakistan', phone_code: '+92' },
  { code: 'PS', name: 'Palestine', phone_code: '+970' },
  { code: 'PW', name: 'Palau', phone_code: '+680' },
  { code: 'PA', name: 'Panama', phone_code: '+507' },
  { code: 'PG', name: 'Papua New Guinea', phone_code: '+675' },
  { code: 'PY', name: 'Paraguay', phone_code: '+595' },
  { code: 'PE', name: 'Peru', phone_code: '+51' },
  { code: 'PH', name: 'Philippines', phone_code: '+63' },
  { code: 'PN', name: 'Pitcairn', phone_code: '+64' },
  { code: 'PL', name: 'Poland', phone_code: '+48' },
  { code: 'PT', name: 'Portugal', phone_code: '+351' },
  { code: 'PR', name: 'Puerto Rico', phone_code: '+1-787' },
  { code: 'QA', name: 'Qatar', phone_code: '+974' },
  { code: 'RE', name: 'Reunion', phone_code: '+262' },
  { code: 'RO', name: 'Romania', phone_code: '+40' },
  { code: 'RU', name: 'Russia', phone_code: '+7' },
  { code: 'RW', name: 'Rwanda', phone_code: '+250' },
  { code: 'BL', name: 'Saint Barthelemy', phone_code: '+590' },
  { code: 'SH', name: 'Saint Helena, Ascension and Tristan da Cunha', phone_code: '+290' },
  { code: 'KN', name: 'Saint Kitts and Nevis', phone_code: '+1-869' },
  { code: 'LC', name: 'Saint Lucia', phone_code: '+1-758' },
  { code: 'MF', name: 'Saint Martin (French part)', phone_code: '+590' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', phone_code: '+508' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', phone_code: '+1-784' },
  { code: 'WS', name: 'Samoa', phone_code: '+685' },
  { code: 'SM', name: 'San Marino', phone_code: '+378' },
  { code: 'ST', name: 'Sao Tome and Principe', phone_code: '+239' },
  { code: 'SA', name: 'Saudi Arabia', phone_code: '+966' },
  { code: 'SN', name: 'Senegal', phone_code: '+221' },
  { code: 'RS', name: 'Serbia', phone_code: '+381' },
  { code: 'SC', name: 'Seychelles', phone_code: '+248' },
  { code: 'SL', name: 'Sierra Leone', phone_code: '+232' },
  { code: 'SG', name: 'Singapore', phone_code: '+65' },
  { code: 'SX', name: 'Saint Maarten (Dutch part)', phone_code: '+1-721' },
  { code: 'SK', name: 'Slovakia', phone_code: '+421' },
  { code: 'SI', name: 'Slovenia', phone_code: '+386' },
  { code: 'SB', name: 'Solomon Islands', phone_code: '+677' },
  { code: 'SO', name: 'Somalia', phone_code: '+252' },
  { code: 'ZA', name: 'South Africa', phone_code: '+27' },
  { code: 'SS', name: 'South Sudan', phone_code: '+211' },
  { code: 'ES', name: 'Spain', phone_code: '+34' },
  { code: 'LK', name: 'Sri Lanka', phone_code: '+94' },
  { code: 'SD', name: 'Sudan', phone_code: '+249' },
  { code: 'SR', name: 'Suriname', phone_code: '+597' },
  { code: 'SZ', name: 'Swaziland', phone_code: '+268' },
  { code: 'SE', name: 'Sweden', phone_code: '+46' },
  { code: 'CH', name: 'Switzerland', phone_code: '+41' },
  { code: 'SY', name: 'Syria', phone_code: '+963' },
  { code: 'TW', name: 'Taiwan, Province of China', phone_code: '+886' },
  { code: 'TJ', name: 'Tajikistan', phone_code: '+992' },
  { code: 'TZ', name: 'Tanzania', phone_code: '+255' },
  { code: 'TH', name: 'Thailand', phone_code: '+66' },
  { code: 'TL', name: 'East Timor', phone_code: '+670' },
  { code: 'TG', name: 'Togo', phone_code: '+228' },
  { code: 'TK', name: 'Tokelau', phone_code: '+690' },
  { code: 'TO', name: 'Tonga', phone_code: '+676' },
  { code: 'TT', name: 'Trinidad and Tobago', phone_code: '+1-868' },
  { code: 'TN', name: 'Tunisia', phone_code: '+216' },
  { code: 'TR', name: 'Turkey', phone_code: '+90' },
  { code: 'TM', name: 'Turkmenistan', phone_code: '+993' },
  { code: 'TC', name: 'Turks and Caicos Islands', phone_code: '+1-649' },
  { code: 'TV', name: 'Tuvalu', phone_code: '+688' },
  { code: 'UG', name: 'Uganda', phone_code: '+256' },
  { code: 'UA', name: 'Ukraine', phone_code: '+380' },
  { code: 'AE', name: 'United Arab Emirates', phone_code: '+971' },
  { code: 'GB', name: 'United Kingdom', phone_code: '+44' },
  { code: 'US', name: 'United States', phone_code: '+1' },
  { code: 'UY', name: 'Uruguay', phone_code: '+598' },
  { code: 'UZ', name: 'Uzbekistan', phone_code: '+998' },
  { code: 'VU', name: 'Vanuatu', phone_code: '+678' },
  { code: 'VE', name: 'Venezuela', phone_code: '+58' },
  { code: 'VN', name: 'Vietnam', phone_code: '+84' },
  { code: 'VG', name: 'Virgin Islands, British', phone_code: '+1-284' },
  { code: 'VI', name: 'Virgin Islands, U.S.', phone_code: '+1-340' },
  { code: 'YE', name: 'Yemen', phone_code: '+967' },
  { code: 'ZM', name: 'Zambia', phone_code: '+260' },
  { code: 'ZW', name: 'Zimbabwe', phone_code: '+263' }
];

export const DEFAULT_PHONE_COUNTRY_CODE_OPTION = {
  label: '+372',
  value: '+372',
  countryCode: 'EE'
};

export const BANK_COUNTRIES: { code: string; name: string }[] = [
  { code: 'at', name: 'Austria' },
  { code: 'be', name: 'Belgium' },
  { code: 'bg', name: 'Bulgaria' },
  { code: 'hr', name: 'Croatia' },
  { code: 'cy', name: 'Cyprus' },
  { code: 'cz', name: 'Czech Republic' },
  { code: 'dk', name: 'Denmark' },
  { code: 'ee', name: 'Estonia' },
  { code: 'fi', name: 'Finland' },
  { code: 'fr', name: 'France' },
  { code: 'de', name: 'Germany' },
  { code: 'gr', name: 'Greece' },
  { code: 'hu', name: 'Hungary' },
  { code: 'is', name: 'Iceland' },
  { code: 'ie', name: 'Ireland' },
  { code: 'it', name: 'Italy' },
  { code: 'la', name: 'Laos' },
  { code: 'lv', name: 'Latvia' },
  { code: 'li', name: 'Liechtenstein' },
  { code: 'lt', name: 'Lithuania' },
  { code: 'lu', name: 'Luxembourg' },
  { code: 'mt', name: 'Malta' },
  { code: 'nl', name: 'Netherlands' },
  { code: 'no', name: 'Norway' },
  { code: 'pl', name: 'Poland' },
  { code: 'pt', name: 'Portugal' },
  { code: 'ro', name: 'Romania' },
  { code: 'sk', name: 'Slovakia' },
  { code: 'si', name: 'Slovenia' },
  { code: 'es', name: 'Spain (España)' },
  { code: 'se', name: 'Sweden' },
  { code: 'gb', name: 'United Kingdom' }
];

export const LOCALE_AND_LANGUAGE_NAMES = {
  af_ZA: ['Afrikaans', 'Afrikaans'],
  ar: ['العربية', 'Arabic'],
  bg_BG: ['Български', 'Bulgarian'],
  ca_AD: ['Català', 'Catalan'],
  cs_CZ: ['Čeština', 'Czech'],
  cy_GB: ['Cymraeg', 'Welsh'],
  da_DK: ['Dansk', 'Danish'],
  de_AT: ['Deutsch (Österreich)', 'German (Austria)'],
  de_CH: ['Deutsch (Schweiz)', 'German (Switzerland)'],
  de_DE: ['Deutsch (Deutschland)', 'German (Germany)'],
  el_GR: ['Ελληνικά', 'Greek'],
  en_GB: ['English (UK)', 'English (UK)'],
  en_US: ['English (US)', 'English (US)'],
  es_CL: ['Español (Chile)', 'Spanish (Chile)'],
  es_ES: ['Español (España)', 'Spanish (Spain)'],
  es_MX: ['Español (México)', 'Spanish (Mexico)'],
  et_EE: ['Eesti keel', 'Estonian'],
  eu: ['Euskara', 'Basque'],
  fa_IR: ['فارسی', 'Persian'],
  fi_FI: ['Suomi', 'Finnish'],
  fr_CA: ['Français (Canada)', 'French (Canada)'],
  fr_FR: ['Français (France)', 'French (France)'],
  he_IL: ['עברית', 'Hebrew'],
  hi_IN: ['हिंदी', 'Hindi'],
  hr_HR: ['Hrvatski', 'Croatian'],
  hu_HU: ['Magyar', 'Hungarian'],
  id_ID: ['Bahasa Indonesia', 'Indonesian'],
  is_IS: ['Íslenska', 'Icelandic'],
  it_IT: ['Italiano', 'Italian'],
  ja_JP: ['日本語', 'Japanese'],
  km_KH: ['ភាសាខ្មែរ', 'Khmer'],
  ko_KR: ['한국어', 'Korean'],
  la: ['Latina', 'Latin'],
  lt_LT: ['Lietuvių kalba', 'Lithuanian'],
  lo_LA: ['ພາສາລາວ', 'Lao'],
  lv_LV: ['Latviešu', 'Latvian'],
  mn_MN: ['Монгол', 'Mongolian'],
  nb_NO: ['Norsk bokmål', 'Norwegian (Bokmål)'],
  nl_NL: ['Nederlands', 'Dutch'],
  nn_NO: ['Norsk nynorsk', 'Norwegian (Nynorsk)'],
  pl_PL: ['Polski', 'Polish'],
  pt_BR: ['Português (Brasil)', 'Portuguese (Brazil)'],
  pt_PT: ['Português (Portugal)', 'Portuguese (Portugal)'],
  ro_RO: ['Română', 'Romanian'],
  ru_RU: ['Русский', 'Russian'],
  sk_SK: ['Slovenčina', 'Slovak'],
  sl_SI: ['Slovenščina', 'Slovenian'],
  sr_RS: ['Српски / Srpski', 'Serbian'],
  sv_SE: ['Svenska', 'Swedish'],
  th_TH: ['ไทย', 'Thai'],
  tr_TR: ['Türkçe', 'Turkish'],
  uk_UA: ['Українська', 'Ukrainian'],
  vi_VN: ['Tiếng Việt', 'Vietnamese'],
  zh_CN: ['中文 (中国大陆)', 'Chinese (PRC)'],
  zh_TW: ['中文 (台灣)', 'Chinese (Taiwan)']
};

export const vatMOSSRates = {
  AT: 0.2,
  BE: 0.21,
  BG: 0.2,
  CY: 0.19,
  CZ: 0.21,
  DE: 0.19,
  DK: 0.25,
  EE: 0.24,
  EL: 0.24,
  ES: 0.21,
  FI: 0.24,
  FR: 0.2,
  HR: 0.25,
  HU: 0.27,
  IE: 0.23,
  IT: 0.22,
  LT: 0.21,
  LU: 0.17,
  LV: 0.21,
  MT: 0.18,
  NL: 0.21,
  PL: 0.23,
  PT: 0.23,
  RO: 0.19,
  SE: 0.25,
  SI: 0.22,
  SK: 0.2
};

export const LANGUAGE_OPTIONS: Option<UserLocale>[] = [
  {
    value: 'en_US',
    label: LOCALE_AND_LANGUAGE_NAMES.en_US[0]
  },
  {
    value: 'es_ES',
    label: LOCALE_AND_LANGUAGE_NAMES.es_ES[0]
  }
];

export type CountryOption = { label: string; value: string };

export const currencyOptions: Option<GenericSelectOption>[] = CURRENCIES.map((country: any) => ({
  label: country.name,
  value: country.code
}));

export const COUNTRIES_FROM_EU = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LA',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE'
];
